import styled from 'styled-components'

export const NFTShareModalWrapper = styled.div`
  width: 100%;
  padding: 1rem;
`

export const NFTShareModalMeta = styled.div`
  width: 100%;
  padding-bottom: 1rem;
  font-weight: bold;
  font-size: 1.2rem;
  text-align: center;
`

export const NFTShareModalShareLinks = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  .nft-share-button {
    margin-right: 1.5rem;
    margin-bottom: 1rem;
    display: flex;
    flex-direction: column;

    :last-child {
      margin-right: 0;
    }

    button {
      outline: none;
    }

    .nft-share-button-text {
      font-size: 0.7rem;
      opacity: 0.8;
      width: 100%;
      text-align: center;
    }
  }
`
